import React, { FunctionComponent } from 'react'
import { getConfigValue } from 'src/utils/config/config'
import { EventLocation, IEventLocationProps } from './event_location'

// `showAddress` is what this container answers; taking it as a prop would let a
// call site set a value that is then overwritten one line later.
export const EventLocationContainer: FunctionComponent<
  Omit<IEventLocationProps, 'showAddress'>
> = props => {
  // Only the address hangs on the map feature: an instance that brings its own
  // address hides the row because every event carries the same one, and an
  // instance without a map has nothing to show it on. Neither says anything
  // about a link to an online event, which is why the gate stops here.
  let showAddress = getConfigValue<boolean>('featureFlags.map.enabled')
  if (getConfigValue('featureFlags.location.defaultAddress')) {
    showAddress = false
  }

  return <EventLocation {...props} showAddress={showAddress} />
}
